module.exports = __webpack_public_path__ + "media/images/guides/random-05-67e3040a68c8bbab5ac9916f42207cb1.svg";